import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SEO from '../components/SEO';
import { PageHero, SectionHeading } from '../components/Reveal';
import { ArticleCard } from '../components/home/ResourcesHub';
import FreeResources from '../components/home/FreeResources';
import { ARTICLES } from '../data/content';

const CATEGORIES = ['All', ...new Set(ARTICLES.map((a) => a.category))];

const Resources = () => {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? ARTICLES : ARTICLES.filter((a) => a.category === active);

  return (
    <main data-testid="resources-page">
      <SEO
        title="Career Knowledge Hub — Guides, Skills & Career Trends | CareerWithRaaj"
        description="Career guides, course & college selection guides, stream selection help, skill development, interview preparation, resume tips and career trends."
      />
      <PageHero
        overline="Knowledge Hub"
        title="Career Knowledge Hub"
        description="Practical guides on streams, courses, colleges, skills, and careers — written to help you decide with clarity."
      />

      <section className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <SectionHeading index="01" overline="Articles" title="Guides & Insights" />
          <div className="no-scrollbar mt-10 flex gap-2.5 overflow-x-auto pb-2" role="tablist" aria-label="Resource categories">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                role="tab"
                aria-selected={active === c}
                onClick={() => setActive(c)}
                data-testid={`resource-filter-${c.toLowerCase().replace(/[\s&]+/g, '-')}`}
                className={`whitespace-nowrap rounded-full border px-5 py-2.5 text-sm font-semibold transition-[background-color,color,border-color] duration-200 ${
                  active === c
                    ? 'border-coral bg-coral text-white'
                    : 'border-line bg-white text-navy/70 hover:border-navy/40 hover:text-navy'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <AnimatePresence mode="wait">
            <motion.div
              key={active}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.35 }}
              className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
            >
              {filtered.map((a) => (
                <ArticleCard key={a.title} article={a} />
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      <FreeResources />
    </main>
  );
};

export default Resources;
